// YSNONA: 000000=NO; 000001=YES; 000002=N/A
// NO - YES: 000000 = NO; 000001 = YES

import { Exclude, plainToClass, Type } from "class-transformer";
import Decimal from "decimal.js";
import { FileModel } from "./FileModel";

export type YSNO = "000000" | "000001";
export type YSNONA = YSNO | "000002";

export class BudgetComponentsRow {
    actual_expenditure!: number;
    cost_budgeted?: number;
    cost_expenditure!: number;
    id_line_item!: number;
    type_description!: string;
    remarks?: string;
    component?: string;
    ds_attivita?: string
    ds_proposta?: string
    budget_fkid?: number
    upload_urls!: string[]

    @Exclude()
    get isValid(): string | null {
        if (typeof this.actual_expenditure !== 'number') {
            return !this.remarks ? "remarks" : null;
        }
        if (this.actual_expenditure >= 0) {
            return this.actual_expenditure === 0 ? !this.remarks ? "remarks" : null : null;
        } else {
            return "remarks";
        }
    }
}

export class BudgetComponentsM6P1Row {
    type_description!: number | null;
    actual_expenditure!: number;
    remarks?: string;

    @Exclude()
    get isValid(): string | null {
        if (typeof this.actual_expenditure !== 'number') {
            return !this.remarks ? "remarks" : null;
        } else if (typeof this.actual_expenditure === 'number' && this.actual_expenditure >= 0) {
            return this.actual_expenditure === 0 ? !this.remarks ? "remarks" : null : null;
        } else {
            return "remarks";
        }
    }

    @Exclude()
    get isEmpty() {
        return typeof this.actual_expenditure !== "number" && !this.type_description && !this.remarks;
    }
}

class BudgetComponentsTotals {
    total_claim_advanced!: number;
    total_claim_others!: number;
    total_claim_both!: number;
}

class BudgetComponentsM6P1Totals {
}

export class BudgetComponentsResponse {
    @Type(() => BudgetComponentsRow)
    rows!: BudgetComponentsRow[];
    @Type(() => BudgetComponentsTotals)
    totals!: BudgetComponentsTotals;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        for(const i in this.rows) {
            const isValid = this.rows[i].isValid;
            if(typeof isValid === "string") {
                errors.push(`${isValid}_${i}`);
            }
        }
        return errors;
    }

    @Exclude()
    get total() {
        return this.rows
            .map(e => e.actual_expenditure)
            .reduce((acc, cur) => acc.add(typeof cur === "number" ? cur : 0), new Decimal(0))
            .toNumber();
    }
}

export class BudgetComponentsResponseM6P1 {
    @Type(() => BudgetComponentsM6P1Row)
    rows!: BudgetComponentsM6P1Row[];
    @Type(() => BudgetComponentsM6P1Totals)
    totals!: BudgetComponentsM6P1Totals;

    get filtered(): BudgetComponentsM6P1Row[] {
        return plainToClass(BudgetComponentsM6P1Row, this.rows).filter(e => !e.isEmpty);
    }

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        for (const i in this.rows) {
            const isValid = this.rows[i].isValid;
            if (typeof isValid === "string") {
                errors.push(`${isValid}_${i}`);
            }
        }
        return errors;
    }
}

export class ProjectStatusUpdate extends FileModel {
    ppr_status_update_08!: string;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        !this.ppr_status_update_08 && errors.push("ppr_status_update_08");
        if(this.file_ids.length + this.upload_urls.length === 0) {
            errors.push("file_ids");
        }
        return errors;
    }
}

export class BudgetProgress {
    m11_interventions_01_1!: YSNO | null;
    m11_interventions_01_2!: string | null;
    m11_interventions_01_3!: string | null;
    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        !this.m11_interventions_01_1 && errors.push("m11_interventions_01_1");
        const valid1 = this.m11_interventions_01_1 === "000001" ? !!this.m11_interventions_01_2 : true;
        !valid1 && errors.push("m11_interventions_01_2");
        return errors;
    }
}


export class MeasureSpecificTargetsM4P1 {
    m41_specific_target_01_1!: YSNONA | null;
    m41_specific_target_01_2!: string | null;
    m41_specific_target_02_1!: YSNONA | null;
    m41_specific_target_02_2!: string | null;
    m41_specific_target_03_1!: YSNONA | null;
    m41_specific_target_03_2!: string | null;
    m41_specific_target_04_1!: YSNONA | null;
    m41_specific_target_04_2!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        // !this.m41_specific_target_01_1 && errors.push("m41_specific_target_01_1");
        // !this.m41_specific_target_02_1 && errors.push("m41_specific_target_02_1");
        // !this.m41_specific_target_03_1 && errors.push("m41_specific_target_03_1");
        // !this.m41_specific_target_04_1 && errors.push("m41_specific_target_04_1");

        // const valid1 = this.m41_specific_target_01_1 === "000001" ? !!this.m41_specific_target_01_2 : true;
        // const valid2 = this.m41_specific_target_02_1 === "000001" ? !!this.m41_specific_target_02_2 : true;
        // const valid3 = this.m41_specific_target_03_1 === "000001" ? !!this.m41_specific_target_03_2 : true;
        // const valid4 = this.m41_specific_target_04_1 === "000001" ? !!this.m41_specific_target_04_2 : true;

        // !valid1 && errors.push("m41_specific_target_01_2");
        // !valid2 && errors.push("m41_specific_target_02_2");
        // !valid3 && errors.push("m41_specific_target_03_2");
        // !valid4 && errors.push("m41_specific_target_04_2");

        return errors;
    }
}

export class MeasureSpecificTargetsM1P1 {
    specific_target_01_1!: string;
    specific_target_01_2!: string;
    specific_target_01_3!: string;
    specific_target_01_4!: string;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        !this.specific_target_01_1 && errors.push("specific_target_01_1");
        !this.specific_target_01_2 && errors.push("specific_target_01_2");
        !this.specific_target_01_3 && errors.push("specific_target_01_3");
        !this.specific_target_01_4 && errors.push("specific_target_01_4");

        return errors;
    }

}


export interface MeasureSpecificTargetsM4P3Years {
    year1: number | null;
    year2: number | null;
    year3: number | null;
    year4: number | null;
    year5: number | null;
}

export class MeasureSpecificTargetsM4P3Water {
    // m43_specific_target_01_1 --> Length of installed pipes funded by EAFRD (in km)
    m43_specific_target_01_2!: string;
    m43_specific_target_01_3!: string;
    m43_specific_target_01_4!: string;
    m43_specific_target_01_5!: string;
    m43_specific_target_01_6!: string;
    // m43_specific_target_02_1 --> Water dispensed to farmers (in litres)
    m43_specific_target_02_2!: string;
    m43_specific_target_02_3!: string;
    m43_specific_target_02_4!: string;
    m43_specific_target_02_5!: string;
    m43_specific_target_02_6!: string;
    // m43_specific_target_03_1 --> Number of potentially affected farmers
    m43_specific_target_03_2!: string;
    m43_specific_target_03_3!: string;
    m43_specific_target_03_4!: string;
    m43_specific_target_03_5!: string;
    m43_specific_target_03_6!: string;
    years!: MeasureSpecificTargetsM4P3Years;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        // TODO
        return errors;
    }
}


export class MeasureSpecificTargetsM4P3Road implements MeasureSpecificTargetsM4P3Years {
    ds_road!: string | null;
    year1!: number | null;
    year2!: number | null;
    year3!: number | null;
    year4!: number | null;
    year5!: number | null;

    @Exclude()
    get isEmpty() {
        return !this.ds_road &&
            typeof this.year1 !== "number" &&
            typeof this.year2 !== "number" &&
            typeof this.year3 !== "number" &&
            typeof this.year4 !== "number" &&
            typeof this.year5 !== "number";
    }
    @Exclude()
    get isValid() {
        return !this.isEmpty && !!this.ds_road;
    }
}
export class MeasureSpecificTargetsM4P3Roads {
    @Type(() => MeasureSpecificTargetsM4P3Road)
    rows!: MeasureSpecificTargetsM4P3Road[];
    years!: MeasureSpecificTargetsM4P3Years;


    @Exclude()
    get filtered() {
        return plainToClass(MeasureSpecificTargetsM4P3Road, this.rows).filter(e => !e.isEmpty);
    }

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        for(const index in this.rows){
            !this.rows[index].isValid && errors.push("row_" + index);
        }
        return errors;
    }
}

export class MeasureSpecificTargetsM4P4 {
    /*
    M44_SPECIFIC_TARGET_01_0 Description Indicator

    M44_SPECIFIC_TARGET_01_1 Combo - In case of rubble walls, length (in metres) of works completed to date
    M44_SPECIFIC_TARGET_01_2 Decimal - If Yes, please specify:

    M44_SPECIFIC_TARGET_02_1 Combo - In case of rubble walls volume (in m3) of works completed to date
    M44_SPECIFIC_TARGET_02_2 Decimal - If Yes, please specify:

    M44_SPECIFIC_TARGET_03_1 Combo - In case of rubble walls, area (in m2) of works completed to date
    M44_SPECIFIC_TARGET_03_2 Decimal - If Yes, please specify:

    M44_SPECIFIC_TARGET_04_1 Combo - Number of trees planted (where applicable)
    M44_SPECIFIC_TARGET_04_2 Decimal - If Yes, please specify:

    M44_SPECIFIC_TARGET_05_1 Combo - Area (in m2) of agricultural land impacted by the project
    M44_SPECIFIC_TARGET_05_2 Decimal - If Yes, please specify:
    */
    m44_specific_target_01_1!: YSNONA | null;
    m44_specific_target_01_2!: string | null;

    m44_specific_target_02_1!: YSNONA | null;
    m44_specific_target_02_2!: string | null;

    m44_specific_target_03_1!: YSNONA | null;
    m44_specific_target_03_2!: string | null;

    m44_specific_target_04_1!: YSNONA | null;
    m44_specific_target_04_2!: string | null;

    m44_specific_target_05_1!: YSNONA | null;
    m44_specific_target_05_2!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        !this.m44_specific_target_01_1 && errors.push("m44_specific_target_01_1");
        !this.m44_specific_target_02_1 && errors.push("m44_specific_target_02_1");
        !this.m44_specific_target_03_1 && errors.push("m44_specific_target_03_1");
        !this.m44_specific_target_04_1 && errors.push("m44_specific_target_04_1");
        !this.m44_specific_target_05_1 && errors.push("m44_specific_target_05_1");


        const valid1 = this.m44_specific_target_01_1 === "000001" ? !!this.m44_specific_target_01_2 : true;
        const valid2 = this.m44_specific_target_02_1 === "000001" ? !!this.m44_specific_target_02_2 : true;
        const valid3 = this.m44_specific_target_03_1 === "000001" ? !!this.m44_specific_target_03_2 : true;
        const valid4 = this.m44_specific_target_04_1 === "000001" ? !!this.m44_specific_target_04_2 : true;
        const valid5 = this.m44_specific_target_05_1 === "000001" ? !!this.m44_specific_target_05_2 : true;

        !valid1 && errors.push("m44_specific_target_01_2");
        !valid2 && errors.push("m44_specific_target_02_2");
        !valid3 && errors.push("m44_specific_target_03_2");
        !valid4 && errors.push("m44_specific_target_04_2");
        !valid5 && errors.push("m44_specific_target_05_2");

        return errors;
    }
}
export class MeasureSpecificTargetsM6P1 {
    m61_specific_target_01_1!: number | null;

    m61_specific_target_02_1!: YSNO | null;
    m61_specific_target_03_1!: YSNO | null;
    m61_specific_target_04_1!: YSNO | null;

    m61_specific_target_05_1!: YSNONA | null;
    m61_specific_target_05_2!: string | null;
    m61_specific_target_06_1!: YSNONA | null;
    m61_specific_target_06_2!: string | null;
    m61_specific_target_07_1!: YSNONA | null;
    m61_specific_target_07_2!: string | null;
    m61_specific_target_08_1!: YSNONA | null;
    m61_specific_target_08_2!: string | null;

    m61_specific_target_10_1!: YSNO | null;
    m61_specific_target_11_1!: YSNO | null;
    m61_specific_target_12_1!: YSNO | null;
    m61_specific_target_13_1!: YSNO | null;

    @Exclude()
    get isValid(): string[] {

        const errors: string[] = [];

        typeof this.m61_specific_target_01_1 !== "number" && errors.push("m61_specific_target_01_1");

        !this.m61_specific_target_02_1 && errors.push("m61_specific_target_02_1");
        !this.m61_specific_target_03_1 && errors.push("m61_specific_target_03_1");
        !this.m61_specific_target_04_1 && errors.push("m61_specific_target_04_1");

        !this.m61_specific_target_05_1 && errors.push("m61_specific_target_05_1");
        !this.m61_specific_target_06_1 && errors.push("m61_specific_target_06_1");
        !this.m61_specific_target_07_1 && errors.push("m61_specific_target_07_1");
        !this.m61_specific_target_08_1 && errors.push("m61_specific_target_08_1");

        const valid1 = this.m61_specific_target_05_1 === "000001" ? !!this.m61_specific_target_05_2 : true;
        const valid2 = this.m61_specific_target_06_1 === "000001" ? !!this.m61_specific_target_06_2 : true;
        const valid3 = this.m61_specific_target_07_1 === "000001" ? !!this.m61_specific_target_07_2 : true;
        const valid4 = this.m61_specific_target_08_1 === "000001" ? !!this.m61_specific_target_08_2 : true;

        !valid1 && errors.push("m61_specific_target_05_2");
        !valid2 && errors.push("m61_specific_target_06_2");
        !valid3 && errors.push("m61_specific_target_07_2");
        !valid4 && errors.push("m61_specific_target_08_2");

        !this.m61_specific_target_10_1 && errors.push("m61_specific_target_10_1");
        !this.m61_specific_target_11_1 && errors.push("m61_specific_target_11_1");
        !this.m61_specific_target_12_1 && errors.push("m61_specific_target_12_1");
        !this.m61_specific_target_13_1 && errors.push("m61_specific_target_13_1");


        return errors;
    }

}
export class MeasureSpecificTargetsM4P2 {
    m42_specific_target_01_1!: YSNONA | null;
    m42_specific_target_01_2!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        !this.m42_specific_target_01_1 && errors.push("m42_specific_target_01_1");
        const valid1 = this.m42_specific_target_01_1 === "000001" ? !!this.m42_specific_target_01_2 : true;
        !valid1 && errors.push("m42_specific_target_01_2");

        return errors;
    }
}
export class FinalRemarks {
    ppr_final_remark_01!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        // TODO to be implemented!
        // !this.ppr_final_remark_01 && errors.push("ppr_final_remark_01");
        return errors;
    }
}
